import { useEffect, useMemo, useState } from "react";
import axiosInstance from "../../utils/axios";
import ItemProductGrid from "../../section/itemProductGrid";
import "./style.css";

const getTime = (item) => {
  const raw =
    item?.create_at ||
    item?.created_at ||
    item?.createdAt;

  if (!raw) return 0;

  const time = new Date(raw).getTime();

  return Number.isFinite(time) ? time : 0;
};

export default function LatestProducts() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;

    axiosInstance
      .get("/product/getAll?page=1&pageSize=100")
      .then((res) => {
        if (!active) return;

        const body = res?.data;

        const rows = Array.isArray(body?.data)
          ? body.data
          : Array.isArray(body)
          ? body
          : [];

        setProducts(rows);
      })
      .catch(() => {
        if (active) setProducts([]);
      })
      .finally(() => {
        if (active) setLoading(false);
      });

    return () => {
      active = false;
    };
  }, []);

  const latest = useMemo(() => {
    return [...products].sort((a, b) => {
      const ta = getTime(a);
      const tb = getTime(b);

      if (ta !== tb) {
        return tb - ta;
      }

      return (
        Number(b?.product_id || 0) -
        Number(a?.product_id || 0)
      );
    });
  }, [products]);

  useEffect(() => {
    document.title = "Sản phẩm mới nhất | Y KHOA";
  }, []);

  return (
    <main className="cyk-latest-page">
      <div className="cyk-latest-inner">
        <div className="cyk-latest-top">
          <a href="/" className="cyk-latest-back">
            ← Trang chủ
          </a>

          <div>
            <h1>Sản phẩm mới nhất</h1>
            <p>
              Những sản phẩm mới được cập nhật tại Y KHOA
            </p>
          </div>
        </div>

        {loading ? (
          <div className="cyk-latest-status">
            Đang tải sản phẩm...
          </div>
        ) : latest.length > 0 ? (
          <div className="cyk-latest-grid">
            <ItemProductGrid
              product={latest}
              grid={5}
            />
          </div>
        ) : (
          <div className="cyk-latest-status">
            Chưa có sản phẩm.
          </div>
        )}
      </div>
    </main>
  );
}
